module.exports = __webpack_public_path__ + "static/media/college-algebra-completed.8f1f0f9d.svg";